<div class="bg-white pt-4" [ngClass]="!isExpanded ? 'container-lg' : 'container-fluid gutters'">

  <div class="row mb-4">
    <nav class="col-md-3 d-md-block">
      <div class="sidebar-heading d-flex justify-content-between align-items-center px-2 pt-3 mb-1 text-muted">
        <a class="" [routerLink]="['/admin']" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: true}"><h6>Admin</h6>
        </a>
      </div>
      <ul class="nav nav-pills mt-1 flex-column">

<!--        <li class="nav-item">-->
<!--          <a class="nav-link" [routerLink]="['/admin']" routerLinkActive="active"-->
<!--             [routerLinkActiveOptions]="{exact: true}">-->
<!--            <i class="fa fa-fw fa-sm fa-tachometer-alt"></i> Dashboard-->
<!--          </a>-->
<!--        </li>-->

        <li class="nav-item m-2 mb-1 text-muted"><small>Configuration</small></li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/users']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-users"></i> Users
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/companies']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-building"></i> Companies
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/mandant']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-user-tie"></i> Mandants
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/news']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-rss"></i> News
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/helps']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-question"></i> Help
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/flagcategories']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-tag"></i> Flag categories
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/flags']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-tags"></i> Flags
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/markets']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-globe-europe"></i> Markets
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/marketgroups']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-globe"></i> Market groups
          </a>
        </li>


        <li class="nav-item m-2 mb-1 text-muted"><small>Files</small></li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/uploads']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-download"></i> File upload
          </a>
        </li>


        <li class="nav-item m-2 mb-1 text-muted"><small>System</small></li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/logs']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-history"></i> Logs
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/appdomains']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-network-wired"></i> App domains
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/tools']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-tools"></i> Tools
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/roles']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-user-tag"></i> Roles
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/languages']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-flag"></i> Languages
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/translation']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-language"></i> Translations
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/admin/attributes']" routerLinkActive="active">
            <i class="fa fa-fw fa-sm fa-list"></i> Attributes
          </a>
        </li>

      </ul>
    </nav>

    <main role="main" class="col-md-9 mb-4">
      <button type="button" (click)="toggleExpand()"
              class="btn btn-sm btn-light mt-3 float-end d-none d-lg-block">
        <i *ngIf="!isExpanded" class="fas fa-expand-arrows-alt"></i>
        <i *ngIf="isExpanded" class="fas fa-compress-arrows-alt"></i>
      </button>

      <!-- alert message holder -->
      <app-alert-list></app-alert-list>

      <!--<button type="button" class="btn btn-danger d-none" (click)="syncUserCompany()">sync</button>-->

      <router-outlet></router-outlet>
    </main>
  </div>

</div>
